import React, { useEffect, useState } from "react";
import SystemCheckItem from "./SystemCheckItem";
import { FaWifi } from "react-icons/fa";
import NetworkSpeedCheck from "network-speed";
import config from "../../../config/awsconfig.json";
import i18n from "../../../config/i18n";
import { withNamespaces } from "react-i18next";


function CheckInternetConnection(props) {
  const MIN_LIMIT = 0;
  const [info, setInfo] = useState({
    title: i18n.t("Checking_Internet_Connection"),
    ready: i18n.t("WAITING"),
    waitMessage: i18n.t("Please_wait_We_are_checking_your_connection"),
    infoCover: "col-6",
    description:
      i18n.t("A_stable_internet_connection_with_at_least_1_MBps_8Mbps_speed_is_required"),
    descriptionCover: "col-6",
    buttonText: i18n.t("Next_Step"),
  });

  const CheckNetworkConnectionStatus = () => {
    if (!navigator.onLine) {
      setInfo((info) => ({
        ...info,
        waitMessage: i18n.t("SlowUnstable_connection_detected_Please_check_your_connection_and_repeat_the_system_check"),
      }));
    } else {
      setInfo((info) => ({
        ...info,
        ready: "OK",
        waitMessage: i18n.t("Success_Please_click_Next_Step_to_proceed"),
      }));
    }
  }

  useEffect(() => {
    /* const getNetworkDownloadSpeed = async () => {
      const checkNetworkSpeed = new NetworkSpeedCheck();
      const baseUrl = `https://${config.s3.files}.s3-eu-west-1.amazonaws.com/system-check/10MB.zip?${(new Date()).getTime()}`;
      const fileSizeInBytes = 10000000;
      const speed = await checkNetworkSpeed.checkDownloadSpeed(
        baseUrl,
        fileSizeInBytes
      );
      if (parseFloat(speed.mbps) > MIN_LIMIT) {
        setInfo((info) => ({
          ...info,
          ready: "OK",
          waitMessage: i18n.t("Success_Please_click_Next_Step_to_proceed"),
        }));
      } else {
        setInfo((info) => ({
          ...info,
          waitMessage: i18n.t("SlowUnstable_connection_detected_Please_check_your_connection_and_repeat_the_system_check"),
        }));
      }
    };

    const checkNetworkDownloadSpeed = async () => {
      await getNetworkDownloadSpeed();
    };
    
    checkNetworkDownloadSpeed(); */

    setTimeout(CheckNetworkConnectionStatus(), 5000);
    
  }, []);

  return (
    <SystemCheckItem
      Icon={
        <FaWifi size={200} color={info.ready === "OK" ? "#29377e" : "gray"} />
      }
      info={info}
      buttonHandler={props.buttonHandler}
      next={props.next}
      prev={props.prev}
      handleRepeatClick={props.handleRepeatClick}
      repeatableButton={true}
      configuration={props.configuration}
      currentStep={props.currentStep}
    />
  );
}
export default withNamespaces()(CheckInternetConnection);